import ShoppingListsItem from './ShoppingListsItem';

export default ShoppingListsItem;
